export default __webpack_public_path__ + "static/media/icon-gestao.745725d6.svg";